export default "__VITE_ASSET__29c46813__"